import { render, staticRenderFns } from "./MenuProps.vue?vue&type=template&id=069ad8c1&"
import script from "./MenuProps.vue?vue&type=script&lang=js&"
export * from "./MenuProps.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports